// extracted by mini-css-extract-plugin
module.exports = {"all_component":"Home_all_component__-L3-j"};